<svg
  width="25"
  height="26"
  viewBox="0 0 25 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_86_733)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.8743 6.52576C13.8743 5.86302 13.337 5.32576 12.6743 5.32576C12.0115 5.32576 11.4743 5.86302 11.4743 6.52576V11.8L6.2 11.8C5.53726 11.8 5 12.3373 5 13C5 13.6627 5.53726 14.2 6.2 14.2L11.4743 14.2V19.4742C11.4743 20.137 12.0115 20.6742 12.6743 20.6742C13.337 20.6742 13.8743 20.137 13.8743 19.4742V14.2L19.1485 14.2C19.8112 14.2 20.3485 13.6627 20.3485 13C20.3485 12.3373 19.8112 11.8 19.1485 11.8L13.8743 11.8V6.52576Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_86_733">
      <rect width="25" height="25" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
